// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bdG5V","delete":"styles_delete__1rorA","update":"styles_update__2A4Ol","add":"styles_add__FytIW"};